import script from "./StoreAdminGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreAdminGuide.vue?vue&type=script&setup=true&lang=js"

import "./StoreAdminGuide.vue?vue&type=style&index=0&id=6979dc2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6979dc2e"]])

export default __exports__